export class Utils {
	public static GetRandomArbitrary(min, max){
		return Math.random() * (max - min) + min;
	};
}